import {
  Box,
  Grid,
  IconButton,
  Link,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import logo from "../../static/favicon.png";
import { useLocation } from "react-router-dom";
import useAxios from "../hooks/useAxios";
import { links } from "./links";
import { coinHighscoresApi } from "../apis/coin-highscores";
import {ActivityLog} from '../components/activitylog'
import "./Home.css"
import { PlayerShopsLog } from "../components/playershopslog";

interface Props {
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>;
}

export default function Home({ setSelectedIndex }: Props) {
  const { pathname } = useLocation();

  const [coinsHighscores, error, loading, axiosFetch] = useAxios();

  useEffect(() => {
    setSelectedIndex(-1);
  }, [setSelectedIndex]);

  useEffect(() => {
    document.title = process.env.REACT_APP_NAME!;
  }, [pathname]);

  const getData = () => {
    axiosFetch({
      axiosInstance: coinHighscoresApi,
      method: "get",
    });
  };


  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: `calc(100vh - 20px - 33px)` }}
    >
      <Grid item xs={3} className="activ">
        <Stack direction={{ xs: "column", sm: "row-reverse" }} spacing={2}>
          <Box display="flex" sx={{ justifyContent: "center" }}>
            <img src={logo} width="300px" alt="logo" />
          </Box>
          <Box>
            <Grid
              display="flex"
              justifyContent={{ xs: "center", sm: "flex-start" }}
            >
              <Typography variant="h3">{process.env.REACT_APP_NAME}</Typography>
            </Grid>
            <Grid
              display="flex"
              justifyContent={{ xs: "center", sm: "flex-start" }}
            >
              <Typography variant="subtitle1" gutterBottom>
                <p>Fishbot official portal</p>
                <h1 className="gebralta"><a href='https://twitch.tv/irm_tv' target="new">Play Now!</a></h1>
                <h2>Why not check out the <a href='./#/Wiki'>Brand New Wiki</a></h2>
                {/* Better an{' '}
                <Box fontWeight="fontWeightMedium" display="inline">
                  oops
                </Box>{' '}
                than a{' '}
                <Box fontWeight="fontWeightMedium" display="inline">
                  what if
                </Box> */}
              </Typography>
            </Grid>
            {/* <Grid
              display="flex"
              justifyContent={{ xs: "center", sm: "flex-start" }}
            >
              <Stack direction="row" spacing={0.4}>
                {links.map((link) => (
                  <Tooltip key={link.index} title={link.title} arrow>
                    <Link
                      target="_blank"
                      href={link.href}
                      underline="none"
                      color="inherit"
                    >
                      <IconButton color="inherit">{link.icon}</IconButton>
                    </Link>
                  </Tooltip>
                ))}
              </Stack>
            </Grid> */}

          </Box>
        </Stack>
      </Grid>
      <Grid item xs={3} className="homewidgets">
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <Box className="activ">
          <h3>On the lake:</h3>
          <ActivityLog/>
        </Box>
        <Box className="psshopslog">
          <h3>Player shops:</h3>
          <PlayerShopsLog/>
        </Box>
        </Stack>
      </Grid>

      <Grid item xs={1}>
        <div className='ttx'>
            Made by:
            <br></br>
      <div className='devDiv'>
            <div className='devavvy' > <img className='devimg' src='phxavvy.png' /> </div><p className='theT'>PHX</p>
            <div className='devavvy' >     <img className='devimg'  src='berryav.png' /> </div><p className='theT'>berry</p>
            <div className='devavvy' >   <img className='devimg' src='shortyav.png' /> </div><p className='theT'>SQUID</p>
            </div>
            </div>
            </Grid>
    </Grid>
  );
}
